export const deviceTypes = {
    desktop: 1,
    laptop: 2,
    tablet: 3,
    mobile: 4
}